require('./signalement-antenniste.scss');

import DemandeActions from '../../../../actions/demande.actions';
import { STEPS } from '../../../../utils/routes.util';
import { NATURE_PERTURBATION } from '../../../common/model';

export default class SignalementAntennisteComponent {
  constructor() {
    this.controller = SignalementAntennisteController;
    this.template = require('./signalement-antenniste.html');
  }
}

// @ngInject
class SignalementAntennisteController {

  constructor($scope, $ngRedux) {
    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.NATURE_PERTURBATION = NATURE_PERTURBATION;
    this.data = {
      natureProbleme: '',
    };
  }

  $onInit() {
    // Demande de récupération de la demande avant connexion au state
    this.$ngRedux.dispatch(DemandeActions.loadDemande(STEPS.SIGNALEMENT_ANTENNISTE));
    // Connexion au state récupérer les données modifiées
    const disconnect = this.$ngRedux.connect(
      state => {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          data: state.demande.data.signalementAntenniste ? state.demande.data.signalementAntenniste.asMutable({deep: true}) : this.data
        };
      }
    )(this);

    // Déconnexion du state à la suppression du composant
    this.$scope.$on('$destroy', disconnect);
  }

  // Actions
  prevStep() {
    this.$ngRedux.dispatch(DemandeActions.updateSignalementAntenniste(this.data, true));
  }
  nextStep() {
    this.$ngRedux.dispatch(DemandeActions.updateSignalementAntenniste(this.data));
  }
}



// WEBPACK FOOTER //
// ./src/modules/accueil/components/signalement-antenniste/signalement-antenniste.component.js